module.exports = __webpack_public_path__ + "review.b09e78d7.png";